import styled, { keyframes, css } from "styled-components";

// Animación de fade-in y desplazamiento hacia arriba
export const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(10px);
  }
`;

export const FabContainer = styled.div`
  position: fixed;
  bottom: 16px;
  right: 16px;
`;

export const FabButton = styled.button`
  background-color: var(--color-primary);
  color: white;
  border: none;
  border-radius: 50%;
  width: 56px;
  height: 56px;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: hsla(24, 100%, 40%, 1);
  }
`;

export const Popover = styled.div`
  position: absolute;
  bottom: 70px;
  right: 0;
  background: white;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  padding: 10px;
  min-width: max-content;
  /* min-width: 200px; */
  opacity: ${(props) => (props.$isOpen ? 1 : 0)};
  transform: translateY(${(props) => (props.$isOpen ? "0px" : "10px")});
  transition: opacity 0.3s ease, transform 0.3s ease;
  animation: ${(props) => (props.$isOpen ? fadeIn : fadeOut)} 0.3s ease;
`;

export const FamilyItem = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s;
  gap: 8px;
  &:hover {
    background: #f0f0f0;
  }
`;

export const Avatar = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid #bbb;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
  color: white;
  /* background: transparent; */
  position: relative;

  ${(props) =>
    props.selected &&
    css`
      background: #4caf50;
      border-color: #4caf50;
      color: white;
    `}
`;

export const CheckIcon = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  color: white;
`;

export const Label = styled.label`
  position: absolute;
  left: 10px;
  cursor: pointer;
  top: ${(props) => (props.$isActive ? "-8px" : "12px")};
  font-size: ${(props) => (props.$isActive ? "12px" : "16px")};
  color: ${(props) =>
    props.$isOpen ? "#007bff" : props.$isSelected ? "#aaa" : "#aaa"};
  background: white;
  padding: 0 5px;
  transition: all 0.3s ease-in-out;
  z-index: 1; /* Mantener al frente */
  opacity: ${(props) => (props.$isActive ? "1" : "0")}; /* Transición suave */
  transform: translateY(${(props) => (props.$isActive ? "0" : "10px")});
`;

export const SelectContainer = styled.div`
  border: ${(props) =>
    props.$isOpen ? "2px solid #007bff" : "2px solid #ccc"};
  border-radius: 5px;
  padding: 12px;
  position: relative;
  background: white;
  font-size: 14px;
  font-weight: 500;
  max-height: 44px;
  color: var(--color-latex30);
  transition: border-color 0.3s ease-in-out;
  ${({ $isOpen, $isActive }) =>
    $isOpen &&
    !$isActive &&
    css`
      padding: 20px 12px;
    `}

  /* Animamos la opacidad para suavizar la reaparición del placeholder */
    span {
    transition: opacity 0.3s ease-in-out;
    opacity: ${(props) => (props.$isOpen || props.$isActive ? "0" : "1")};
  }
`;

export const Container = styled.div`
  /* margin-top: 30px; */
  width: ${(props) => (props?.$styles?.width ? props.$styles.width : "250px")};
  height: 44px;
  position: relative;
  cursor: pointer;
  user-select: none;
  font-weight: initial;
  &:hover ${Label} {
    color: #007bff;
  }
  &:hover ${SelectContainer} {
    border: 2px solid #007bff;
  }
`;

export const DropdownList = styled.ul`
  position: absolute;
  width: 100%;
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: ${(props) => (props.$isOpen ? "150px" : "0")};
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
  border: ${(props) => (props.$isOpen ? "1px solid #ccc" : "none")};
  border-radius: 5px;
  background: white;
  color: var(--color-latex30);
  overflow-y: auto;
  z-index: 1000;
  font-size: 14px;
`;

export const DropdownItem = styled.li`
  padding: 6px 10px;
  cursor: pointer;
  transition: background-color 0.05s ease-in-out;

  &:hover {
    background: var(--color-latex30);
    color: white;
    transition: background-color 0.05s ease-in-out;
  }
`;
